import styles from './Roles.module.css';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';

import Add from '@mui/icons-material/Add';

export const RolesHeader = ({ count, readOnly, onNewRole }) => {
    return (
        <div className={ styles.header }>
            <Typography variant="title">Roles: { count }</Typography>

            <Button onClick={ onNewRole } sx={{ display: readOnly ? 'none' : 'flex' }} size="small" variant="outlined" color="primary" startIcon={ <Icon component={ Add } /> }>
                Add New Role
            </Button>
        </div>
    );
};